import './LuckyButton.scss';

const LuckyButton = ({ onClick, title }) => {
    return (
        <button className="lucky-button" type="button" onClick={onClick}>{title}</button>
    );
};

export default LuckyButton;